import { AxiosInstance } from 'axios';
import { LabelDTO } from '../../types/apiType';

export default class LabelServices {
  constructor(private axios: AxiosInstance) {}

  getAllLabels = async (): Promise<LabelDTO[]> => {
    const response = await this.axios.get('/label');
    return response.data;
  };

  createLabel = async (label: Partial<LabelDTO>): Promise<LabelDTO> => {
    const response = await this.axios.post('/label', label);
    return response.data;
  };

  updateLabel = async (id: string, label: Partial<LabelDTO>): Promise<LabelDTO> => {
    const response = await this.axios.put(`/label/${id}`, label);
    return response.data;
  };
  
  deleteLabel = async (id: string): Promise<void> => {
    await this.axios.delete(`/label/${id}`);
  }
  
};
